import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { LeveransQuery } from "~app/common/models/integration/viol3/LeveransQuery";
import { LeveransResponseDto } from "~app/common/models/integration/viol3/LeveransResponseDto";
import { Viol3ArbetsorderResponseDTO } from "~app/common/models/integration/viol3/Viol3ArbetsorderResponseDTO";
import { Viol3HistorikResponseDTO } from "~app/common/models/integration/viol3/Viol3HistorikResponseDTO";
import { ITypeAheadResult } from "~app/common/models/type-ahead-result.model";
import { SendViol3XmlResponseDto } from "~app/common/models/viol3/SendViol3XmlResponseDto";
import { ICommand } from "~app/common/services/cqs/command.service";
import { ApiClientService } from "../../../../../../common/services/api-client.service";
import { IXmlContainerResponse } from "../models/IntegrationModel";

@Injectable({
    providedIn: "root"
})
export class IntegrationService {
    private readonly apiClient = inject(ApiClientService);

    getArbetsorderByArbetsorderBeteckning(arbetsorderBeteckning: string): Observable<Viol3ArbetsorderResponseDTO> {
        return this.apiClient.get<Viol3ArbetsorderResponseDTO>(`administration/integration/arbetsorder/${arbetsorderBeteckning}`);
    }

    getViol3Xml(arbetsorderBeteckning: string): Observable<IXmlContainerResponse> {
        return this.apiClient.get<IXmlContainerResponse>(`administration/integration/viol3/forstaledskontrakt/${arbetsorderBeteckning}`);
    }

    getViol3AckNackXml(naturalKey: string, type: string): Observable<IXmlContainerResponse> {
        return this.apiClient.get<IXmlContainerResponse>(`administration/integration/viol3/viol3AckNackXml/?naturalKey=${naturalKey}&type=${type}`);
    }

    getLeveranser(leveransQuery: LeveransQuery): Observable<LeveransResponseDto[]> {
        return this.apiClient.get<LeveransResponseDto[]>(
            `administration/integration/viol3/leveranser`,
            false,
            leveransQuery);
    }

    sendXml(xml: string, typ: string): Observable<SendViol3XmlResponseDto> {
        const data = {
            xml: xml,
            typ: typ
        };
        return this.apiClient.post<any, SendViol3XmlResponseDto>(`administration/integration/sendviol3Xml`, data);
    }

    sendAckNackXml(xml: string): Observable<any> {
        const data = {
            xml: xml
        };
        return this.apiClient.post<any, any>(`administration/integration/sendviol3AckNackXml`, data);
    }

    getVirkesorderHistorik(arbetsorderBeteckning: string): Observable<Viol3HistorikResponseDTO> {
        return this.apiClient.get<Viol3HistorikResponseDTO>(`administration/integration/historik/${arbetsorderBeteckning}`);
    }

    postJob(job: ICommand) {
        return this.apiClient.post(`cqs/command`, job);
    }

    getForMottagningsplatsTypeAhead(input: string, kundordertyp: string = null): Observable<ITypeAheadResult[]> {
        return this.apiClient.post<any, ITypeAheadResult[]>(
            "typeahead/mottagningsplats",
            {
                input: input,
                kundordertyp: kundordertyp
            },
            false,
            null,
            ApiClientService.JsonHeader
        );
    }
}
